import { FC } from 'react';
import { Flex, type FlexProps } from 'antd';

export interface DetailProps extends FlexProps {
  label?: string;
}

export const Detail: FC<DetailProps> = ({ label, children, ...rest }) =>
  children === null || children === undefined ? null : (
    <Flex gap="small" {...rest}>
      {label && <strong>{label}:</strong>}
      <span>{children}</span>
    </Flex>
  );
